/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Disease } from './Disease';
import {
    DiseaseFromJSON,
    DiseaseFromJSONTyped,
    DiseaseToJSON,
} from './Disease';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface DiseasePagination
 */
export interface DiseasePagination {
    /**
     * 
     * @type {Array<Disease>}
     * @memberof DiseasePagination
     */
    data?: Array<Disease>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof DiseasePagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the DiseasePagination interface.
 */
export function instanceOfDiseasePagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiseasePaginationFromJSON(json: any): DiseasePagination {
    return DiseasePaginationFromJSONTyped(json, false);
}

export function DiseasePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiseasePagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(DiseaseFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function DiseasePaginationToJSON(value?: DiseasePagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(DiseaseToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

